<template>
    <div class="vehicle-info">
        <!-- 标题与生成时间 -->
        <div class="header">
            <h3>二、车辆运行汇总数据</h3>

        </div>
        <div>
            <!-- 车辆信息描述列表 -->
            <el-table :data="tableData" border :cell-class-name="tableCellClassName" :span-method="arraySpanMethod"
                :show-header="false" style="width: 100%;">
                <!-- 第一列：使用状态 -->
                <el-table-column prop="category" width="120" align="center" />
                <!-- 第二列：基本项目 -->
                <el-table-column prop="group" width="120" align="center" />
                <el-table-column prop="item" width="120" align="center" />
                <!-- 第三列：该时间段累计 -->
                <el-table-column prop="periodTotal" align="center" />
                <!-- 第四列：系统总累计 -->
                <el-table-column prop="systemTotal" align="center" />
            </el-table>
        </div>

        <div class="no-page-break-before" style="margin-top: 10px;"></div>
        <div>
            <el-table :data="tableData3" border :cell-class-name="tableCellClassName" :span-method="arraySpanMethod"
                :show-header="false" style="width: 100%;">
                <!-- 第一列：使用状态 -->
                <el-table-column prop="category" width="120" align="center" />
                <!-- 第二列：基本项目 -->
                <el-table-column prop="group" width="120" align="center" />
                <el-table-column prop="item" width="120" align="center" />
                <!-- 第三列：该时间段累计 -->
                <el-table-column prop="periodTotal" align="center" />
                <!-- 第四列：系统总累计 -->
                <el-table-column prop="systemTotal" align="center" />
            </el-table>
        </div>
        <div class="no-page-break-before" style="margin-top: 10px;"></div>
        <div>
            <el-table :data="tableData4" border :span-method="arraySpanMethod" :show-header="false" style="width: 100%;"
                :cell-class-name="tableCellClassName">
                <!-- 第一列：使用状态 -->
                <el-table-column prop="category" width="120" align="center" />
                <!-- 第二列：基本项目 -->
                <el-table-column prop="group" width="120" align="center" />
                <el-table-column prop="item" width="120" align="center" />
                <!-- 第三列：该时间段累计 -->
                <el-table-column prop="periodTotal"  align="center" />
                <!-- 第四列：系统总累计 -->
                <el-table-column prop="systemTotal"  align="center" />
            </el-table>
        </div>
        <div class="no-page-break-before" style="margin-top: 10px;"></div>
        <div>
            <el-table :data="tableData5" border :cell-class-name="tableCellClassName" :span-method="arraySpanMethod"
                :show-header="false" style="width: 100%;">
                <!-- 第一列：使用状态 -->
                <el-table-column prop="category" width="120" align="center" />
                <!-- 第二列：基本项目 -->
                <el-table-column prop="group" width="120" align="center" />
                <el-table-column prop="item" width="120" align="center" />
                <!-- 第三列：该时间段累计 -->
                <el-table-column prop="periodTotal"  align="center" />
                <!-- 第四列：系统总累计 -->
                <el-table-column prop="systemTotal"  align="center" />
            </el-table>
        </div>
        <div class="note-section">
            <el-card shadow="never" class="note-card">
                <div class="note-title">附注：</div>
                <div class="note-content">
                    1.本报告采集的数据来源分为三类：
                    <div class="note-sub-item">a.车辆基本信息中的总数据是发动机出厂运行后的总数据统计；</div>
                    <div class="note-sub-item">b.车辆运行汇总中时间段累计数据是报告时间段内的数据统计；</div>
                    <div class="note-sub-item">c.车辆运行汇总中系统总累计数据是车载安装后总共采集到的数据统计；</div>
                    2.数据分析规定： 本数据的分析重点是时间段内的数据分析，总累计数据作为分析参考。
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
export default {
    name: "VehicleStatisticsTable",
    data() {
        return {
            tableData: [
                // 表头行
                {
                    category: "使用状态",
                    group: "基本项目",
                    item: "",
                    periodTotal: "采集数据",
                    systemTotal: "",
                    isHeader: true
                },
                // 采集数据子表头
                {
                    category: "",
                    group: "",
                    item: "",
                    periodTotal: "该时间段累计",
                    systemTotal: "系统总累计",
                    isHeader: true
                },
                // 车辆运行状态模块
                {
                    category: "车辆运行状态",
                    categoryRowspan: 7,
                    item: "",
                    group: "行驶里程(km)", groupColspan: 2, groupRowspan: 1,
                    periodTotal: "610.000",
                    systemTotal: "109373.600"
                },
                {
                    category: "", item: "",
                    group: "平均速度(不含怠速)(km/h)", groupColspan: 2, groupRowspan: 1,
                    periodTotal: "38.85",
                    systemTotal: "45.55"
                },
                {
                    category: "", item: "",
                    group: "平均速度(含怠速)(km/h)", groupColspan: 2, groupRowspan: 1,
                    periodTotal: "17.72",
                    systemTotal: "29.42"
                },
                {
                    category: "", item: "", groupColspan: 2, groupRowspan: 1,
                    group: "燃油累计使用量 (L)",
                    periodTotal: "0.0",
                    systemTotal: "0.0"
                },
                {
                    category: "", item: "",
                    group: "电量累计消耗 (kwh)", groupColspan: 2, groupRowspan: 1,
                    periodTotal: "468",
                    systemTotal: "81116"
                },
                {
                    category: "", item: "", groupColspan: 2, groupRowspan: 1,
                    group: "平均油耗(L/100km)",
                    periodTotal: "0.00",
                    systemTotal: "0.00"
                },
                {
                    category: "", item: "",
                    group: "平均电耗(kwh/100km)", groupColspan: 2, groupRowspan: 1,
                    periodTotal: "76.72",
                    systemTotal: "80.65"
                },
                // 电动机工作状态模块
                {
                    category: "电动机工作状态", categoryRowspan: 4, item: "",
                    group: "运行时长(hh:mm:ss)", groupColspan: 2, groupRowspan: 1,
                    periodTotal: "34:24:19",
                    systemTotal: "34187:39"
                },
                {
                    category: "", item: "",
                    group: "行驶时长(hh:mm:ss)", groupColspan: 2, groupRowspan: 1,
                    periodTotal: "15:41:40",
                    systemTotal: "2200:56:07"
                },
                {
                    category: "", item: "",
                    group: "过长怠速时长 (hh:mm:ss)", groupColspan: 2, groupRowspan: 1,
                    periodTotal: "18:42:39",
                    systemTotal: "1210:51:32"
                },
                {
                    category: "", item: "",
                    group: "过长怠速比例(%)", groupColspan: 2, groupRowspan: 1,
                    periodTotal: "54.38%",
                    systemTotal: "35.42%"
                },
                {
                    category: "驾驶员操作状态", item: "", categoryRowspan: 12,
                    group: "前门开启次数", groupColspan: 2, groupRowspan: 1,
                    periodTotal: "0",
                    systemTotal: "5529"
                },
                // 操作项数据
                { category: "", item: "", groupColspan: 2, groupRowspan: 1, group: "前门异常开启次数(车速>5km/h)", periodTotal: "--", systemTotal: "--" },
                { category: "", item: "", groupColspan: 2, groupRowspan: 1, group: "中门开启次数", periodTotal: "0", systemTotal: "8211" },
                { category: "", item: "", groupColspan: 2, groupRowspan: 1, group: "中门异常开启次数(车速>5km/h)", periodTotal: "--", systemTotal: "--" },
                { category: "", item: "", groupColspan: 2, groupRowspan: 1, group: "后门开启次数", periodTotal: "--", systemTotal: "--" },
                { category: "", item: "", groupColspan: 2, groupRowspan: 1, group: "后门异常开启次数(车速>5km/h)", periodTotal: "--", systemTotal: "--" },
                { category: "", item: "", groupColspan: 2, groupRowspan: 1, group: "倒挡次数", periodTotal: "56", systemTotal: "7511" },
                { category: "", item: "", groupColspan: 2, groupRowspan: 1, group: "缓速器工作次数", periodTotal: "0", systemTotal: "0" },
                { category: "", item: "", groupColspan: 2, groupRowspan: 1, group: "ABS工作次数", periodTotal: "0", systemTotal: "0" },
                { category: "", item: "", groupColspan: 2, groupRowspan: 1, group: "刹车次数", periodTotal: "1571", systemTotal: "309820" },
                { category: "", item: "", groupColspan: 2, groupRowspan: 1, group: "近光灯开启次数", periodTotal: "14", systemTotal: "2580" },
                { category: "", item: "", groupColspan: 2, groupRowspan: 1, group: "远光灯开启次数", periodTotal: "2", systemTotal: "2363" },

            ],

            tableData3: [
                // 表头行
                {
                    category: "使用状态",
                    group: "基本项目",
                    item: "",
                    periodTotal: "采集数据",
                    systemTotal: "",
                    isHeader: true
                },
                // 采集数据子表头
                {
                    category: "",
                    item: "",
                    periodTotal: "该时间段累计",
                    systemTotal: "系统总累计",
                    isHeader: true
                },
                // 报警故障信息

                {
                    category: "报警故障信息", categoryRowspan: 24,
                    group: "制动蹄片磨损报警", groupRowspan: 2,
                    item: "次数",
                    periodTotal: "0",
                    systemTotal: "0"
                },
                {
                    category: "",
                    group: "",
                    item: "时间(hh:mm:ss)",
                    periodTotal: "00:00:00",
                    systemTotal: "00:00:00"
                },
                // 空滤堵塞报警
                {
                    category: "",
                    group: "空滤堵塞报警", groupRowspan: 2,
                    item: "次数",
                    periodTotal: "0",
                    systemTotal: "0"
                },
                {
                    category: "",
                    group: "空滤堵塞报警",
                    item: "时间(hh:mm:ss)",
                    periodTotal: "00:00:00",
                    systemTotal: "00:00:00"
                },
                // 整车故障次数
                {
                    category: "",
                    group: "整车故障次数", groupRowspan: 4,
                    item: "1级",
                    periodTotal: "0",
                    systemTotal: "0"
                },
                {
                    category: "",
                    group: "整车故障次数",
                    item: "2级",
                    periodTotal: "0",
                    systemTotal: "0"
                },
                {
                    category: "",
                    group: "整车故障次数",
                    item: "3级",
                    periodTotal: "0",
                    systemTotal: "0"
                },
                {
                    category: "",
                    group: "整车故障次数",
                    item: "4级",
                    periodTotal: "0",
                    systemTotal: "0"
                },
                // BMS故障次数
                {
                    category: "",
                    group: "BMS故障次数", groupRowspan: 4,
                    item: "1级",
                    periodTotal: "0",
                    systemTotal: "0"
                },
                {
                    category: "",
                    group: "BMS故障次数",
                    item: "2级",
                    periodTotal: "0",
                    systemTotal: "0"
                },
                {
                    category: "",
                    group: "BMS故障次数",
                    item: "3级",
                    periodTotal: "0",
                    systemTotal: "0"
                },
                {
                    category: "",
                    group: "BMS故障次数",
                    item: "4级",
                    periodTotal: "0",
                    systemTotal: "0"
                },
                // 驱动电机故障次数
                {
                    category: "",
                    group: "驱动电机故障次数", groupRowspan: 4,
                    item: "1级",
                    periodTotal: "0",
                    systemTotal: "0"
                },
                {
                    category: "",
                    group: "驱动电机故障次数",
                    item: "2级",
                    periodTotal: "0",
                    systemTotal: "0"
                },
                {
                    category: "",
                    group: "驱动电机故障次数",
                    item: "3级",
                    periodTotal: "0",
                    systemTotal: "0"
                },
                {
                    category: "",
                    group: "驱动电机故障次数",
                    item: "4级",
                    periodTotal: "0",
                    systemTotal: "0"
                },
                {
                    category: "",
                    group: "油门故障次数", groupRowspan: 4,
                    item: "1级",
                    periodTotal: "0",
                    systemTotal: "0"
                },
                {
                    category: "",
                    group: "油门故障次数",
                    item: "2级",
                    periodTotal: "0",
                    systemTotal: "0"
                },
                {
                    category: "",
                    group: "油门故障次数",
                    item: "3级",
                    periodTotal: "0",
                    systemTotal: "0"
                },
                {
                    category: "",
                    group: "油门故障次数",
                    item: "4级",
                    periodTotal: "0",
                    systemTotal: "0"
                },
                // 气压故障次数
                {
                    category: "",
                    group: "气压故障次数", groupRowspan: 4,
                    item: "1级",
                    periodTotal: "0",
                    systemTotal: "0"
                },
                {
                    category: "",
                    group: "气压故障次数",
                    item: "2级",
                    periodTotal: "0",
                    systemTotal: "0"
                },
                {
                    category: "",
                    group: "气压故障次数",
                    item: "3级",
                    periodTotal: "0",
                    systemTotal: "0"
                },
                {
                    category: "",
                    group: "气压故障次数",
                    item: "4级",
                    periodTotal: "0",
                    systemTotal: "0"
                }

            ],
            tableData4: [
                // 表头行

                {
                    category: "使用状态",
                    group: "基本项目",
                    item: "",
                    periodTotal: "采集数据",
                    systemTotal: "",
                    isHeader: true
                },
                // 采集数据子表头
                {
                    category: "",
                    group: "",
                    item: "",
                    periodTotal: "该时间段累计",
                    systemTotal: "系统总累计",
                    isHeader: true
                },
                {
                    category: "驾驶员不良操作", categoryRowspan: 29,
                    group: "急加速", groupRowspan: 3,
                    item: "次数",
                    periodTotal: "255",
                    systemTotal: "27107"
                },
                { category: "", group: "急加速", item: "时间(hh:mm:ss)", periodTotal: "00:20:43", systemTotal: "38:53:49" },
                { category: "", group: "急加速", item: "时间占比", periodTotal: "2.20%", systemTotal: "" },

                // 急减速
                { category: "", group: "急减速", groupRowspan: 3, item: "次数", periodTotal: "6", systemTotal: "14145" },
                { category: "", group: "急减速", item: "时间(hh:mm:ss)", periodTotal: "00:00:07", systemTotal: "12:47:06" },
                { category: "", group: "急减速", item: "时间占比", periodTotal: "0.01%", systemTotal: "" },

                // 发动机超转
                { category: "", group: "发动机超转", groupRowspan: 3, item: "次数", periodTotal: "0", systemTotal: "0" },
                { category: "", group: "发动机超转", item: "时间(hh:mm:ss)", periodTotal: "00:00:00", systemTotal: "00:00:00" },
                { category: "", group: "发动机超转", item: "时间占比", periodTotal: "0.00%", systemTotal: "" },

                // 驱动电机超速
                { category: "", group: "驱动电机超速", groupRowspan: 2, item: "次数", periodTotal: "0", systemTotal: "0" },
                { category: "", group: "驱动电机超速", item: "时间(hh:mm:ss)", periodTotal: "00:00:00", systemTotal: "00:00:00" },

                // 怠速
                { category: "", group: "怠速", groupRowspan: 3, item: "次数", periodTotal: "24", systemTotal: "4410" },
                { category: "", group: "怠速", item: "时间(hh:mm:ss)", periodTotal: "18:42:39", systemTotal: "1210:51:32" },
                { category: "", group: "怠速", item: "时间占比", periodTotal: "119.22%", systemTotal: "" },

                // 空档滑行
                { category: "", group: "空档滑行", groupRowspan: 3, item: "次数", periodTotal: "0", systemTotal: "0" },
                { category: "", group: "空档滑行", item: "时间(hh:mm:ss)", periodTotal: "00:00:00", systemTotal: "00:00:00" },
                { category: "", group: "空档滑行", item: "时间占比", periodTotal: "0.00%", systemTotal: "" },

                // 怠速开空调
                { category: "", group: "怠速开空调", groupRowspan: 3, item: "次数", periodTotal: "1", systemTotal: "160" },
                { category: "", group: "怠速开空调", item: "时间(hh:mm:ss)", periodTotal: "00:08:36", systemTotal: "21:23:24" },
                { category: "", group: "怠速开空调", item: "时间占比", periodTotal: "0.42%", systemTotal: "" },

                // 纯电开空调
                { category: "", group: "纯电开空调", groupRowspan: 2, item: "次数", periodTotal: "0", systemTotal: "0" },
                { category: "", group: "纯电开空调", item: "时间(hh:mm:ss)", periodTotal: "00:00:00", systemTotal: "00:00:00" },

                // 疲劳驾驶
                { category: "", group: "疲劳驾驶", groupRowspan: 4, item: "次数", periodTotal: "0", systemTotal: "0" },
                { category: "", group: "疲劳驾驶", item: "时间(hh:mm:ss)", periodTotal: "00:00:00", systemTotal: "00:00:00" },
                { category: "", group: "疲劳驾驶", item: "时间占比", periodTotal: "0.00%", systemTotal: "" },
                { category: "", group: "疲劳驾驶", item: "里程(km)", periodTotal: "0.00", systemTotal: "0.000" },

                // 二档起步
                { category: "", group: "二档起步", groupRowspan: 1, item: "次数", periodTotal: "0", systemTotal: "0" },

                // 冷车驾驶
                { category: "", group: "冷车驾驶", groupRowspan: 1, item: "次数", periodTotal: "0", systemTotal: "0" },

                // 离合器半联动
                { category: "", group: "离合器半联动", groupRowspan: 1, item: "时间占比", periodTotal: "0", systemTotal: "0" }

            ],
            tableData5: [
                // 表头行

                {
                    category: "使用状态",
                    item: "基本项目",
                    periodTotal: "采集数据",
                    systemTotal: "",
                    isHeader: true
                },
                // 采集数据子表头
                {
                    category: "",
                    item: "",
                    periodTotal: "该时间段累计",
                    systemTotal: "系统总累计",
                    isHeader: true
                },
                {
                    category: "超速统计", categoryRowspan: 10,
                    group: "总超速信息", groupRowspan: 2,
                    item: "次数",
                    periodTotal: "0",
                    systemTotal: "0"
                },
                { category: "", group: "总超速信息", item: "时间(hh:mm:ss)", periodTotal: "00:00:00", systemTotal: "00:00:00" },

                // 电子围栏超速
                { category: "", group: "电子围栏超速", groupRowspan: 2, item: "次数", periodTotal: "--", systemTotal: "--" },
                { category: "", group: "电子围栏超速", item: "时间(hh:mm:ss)", periodTotal: "00:00:00", systemTotal: "00:00:00" },

                // 超速20%以内
                { category: "", group: "超速20%以内", groupRowspan: 2, item: "次数", periodTotal: "0", systemTotal: "0" },
                { category: "", group: "超速20%以内", item: "时间(hh:mm:ss)", periodTotal: "00:00:00", systemTotal: "00:00:00" },

                // 超速20%-50%
                { category: "", group: "超速20%-50%", groupRowspan: 2, item: "次数", periodTotal: "0", systemTotal: "0" },
                { category: "", group: "超速20%-50%", item: "时间(hh:mm:ss)", periodTotal: "00:00:00", systemTotal: "00:00:00" },

                // 超速50%以上
                { category: "", group: "超速50%以上", groupRowspan: 2, item: "次数", periodTotal: "0", systemTotal: "0" },
                { category: "", group: "超速50%以上", item: "时间(hh:mm:ss)", periodTotal: "00:00:00", systemTotal: "00:00:00" },
                {
                    category: "充电分析", categoryRowspan: 3,
                    group: "累计充电", groupRowspan: 3,
                    item: "次数",
                    periodTotal: "6",
                    systemTotal: "1222"
                },
                { category: "", group: "累计充电", item: "时间(hh:mm:ss)", periodTotal: "03:14:30", systemTotal: "1145:40:45" },
                { category: "", group: "累计充电", item: "电量", periodTotal: "445", systemTotal: "1131059" },

                // 电池状态分析
                { category: "电池状态分析", categoryRowspan: 5, item: "", groupRowspan: 1, groupColspan: 2, group: "电池单体最低电压", periodTotal: "0", systemTotal: "0" },
                { category: "", group: "电池单体最高电压", item: "", groupRowspan: 1, groupColspan: 2, periodTotal: "0", systemTotal: "0" },
                { category: "", group: "电池单体最高温度", item: "", groupRowspan: 1, groupColspan: 2, periodTotal: "0", systemTotal: "0" },
                { category: "", group: "电池组最高电压", item: "", groupRowspan: 1, groupColspan: 2, periodTotal: "0", systemTotal: "0" },
                { category: "", group: "电池组最低电压", item: "", groupRowspan: 1, groupColspan: 2, periodTotal: "0", systemTotal: "0" }

            ]
        };
    },
    methods: {

        // 合并单元格方法
        arraySpanMethod({ row, rowIndex, columnIndex }) {
            //第一行
            if (rowIndex == 0) {
                if (columnIndex === 0) {
                    return {
                        rowspan: 2,
                        colspan: 1
                    };
                }

                if (columnIndex === 1) {
                    return {
                        rowspan: 2,
                        colspan: 2
                    };
                } if (columnIndex === 2) {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
                if (columnIndex === 3) {
                    return {
                        rowspan: 1,
                        colspan: 2
                    };
                }
            } else if (rowIndex == 1) {
                if (columnIndex < 3) {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            } else {

                if (columnIndex === 0) {
                    return {
                        rowspan: row.categoryRowspan || 0,
                        colspan: 1
                    };
                }

                if (columnIndex === 1) {
                    return {
                        rowspan: row.groupRowspan || 0,
                        colspan: row.groupColspan || 1
                    };


                }
                if (columnIndex === 2) {
                    if (row.item == '') {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    } else {
                        return {
                            rowspan: 1,
                            colspan: 1
                        };
                    }
                }

                return {
                    rowspan: 1,
                    colspan: 1
                };
            }


        },
        // 可选：如果需要更精细的单元格样式控制，可添加cell-class-name的处理方法
        tableCellClassName({ row, column, rowIndex, columnIndex }) {
            if (rowIndex == 0 || rowIndex == 1) {
                return "cell-header";
            }
            if (columnIndex == 0 || columnIndex == 1 || columnIndex == 2) {
                return "cell-header";
            }
 
        }
    }
};
</script>
<style scoped>
::v-deep .cell-header {
    background: #E2F0FF !important;
    color: #000 !important;
    border-bottom: 1px solid #000 !important;
    border-right: 1px solid #000 !important;
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

/* 表头单元格样式 */
.header-cell {
    background: #f5f7fa;
    font-weight: bold;
}

/* 模块标签单元格样式 */
.module-label-cell {
    background: #f5f7fa;
    font-weight: 500;
}

/* 统一单元格内边距和行高 */
.table-cell {
    padding: 8px 0;
}

.el-table td {
    border: 1px solid #e6e6e6;
}

::v-deep .el-table .el-table__cell {
    padding: 4px 0;
}

.note-section {
   
    background: #ffffff;
    margin-top: 15px;
}

.note-card {
    border: 1px solid #e6e6e6;
}

.note-title {
    font-weight: 500;
    margin-bottom: 8px;
}

.note-content {
    line-height: 1.8;
}

.note-sub-item {
    text-indent: 2em;
    /* 缩进对齐 */
    margin-top: 4px;
}
</style>